import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CityViewIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CityViewIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M5.27123 21.9459C5.26708 21.9459 5.26297 21.9459 5.25881 21.9458C5.02177 21.9391 4.83505 21.7414 4.84178 21.5044L5.26686 8.48305C5.27361 8.24599 5.47181 8.06013 5.70826 8.06604C5.9453 8.07277 6.13202 8.27039 6.12529 8.50745L5.70021 21.5288C5.69359 21.7617 5.5027 21.9459 5.27123 21.9459Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.3181 22.0215H2.68232C2.44518 22.0215 2.25293 21.8293 2.25293 21.5921C2.25293 21.355 2.44518 21.1627 2.68232 21.1627H21.3181C21.5552 21.1627 21.7474 21.355 21.7474 21.5921C21.7474 21.8293 21.5552 22.0215 21.3181 22.0215Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.63041 6.70212C7.39327 6.70212 7.20102 6.50991 7.20102 6.27275V5.41398H5.9129V6.27275C5.9129 6.5099 5.72065 6.70212 5.48351 6.70212C5.24637 6.70212 5.05412 6.50991 5.05412 6.27275V4.98461C5.05412 4.74746 5.24637 4.55524 5.48351 4.55524H7.63041C7.86755 4.55524 8.0598 4.74745 8.0598 4.98461V6.27275C8.0598 6.5099 7.86755 6.70212 7.63041 6.70212Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.55695 4.98459C6.31981 4.98459 6.12756 4.79238 6.12756 4.55522V2.40834C6.12756 2.17119 6.31981 1.97897 6.55695 1.97897C6.79409 1.97897 6.98634 2.17118 6.98634 2.40834V4.55522C6.98634 4.79237 6.79409 4.98459 6.55695 4.98459Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.27446 8.849H4.83941C4.12912 8.849 3.55127 8.27116 3.55127 7.56089C3.55127 6.85062 4.12912 6.27275 4.83941 6.27275H8.27446C8.98475 6.27275 9.5626 6.85059 9.5626 7.56089C9.5626 8.27119 8.98475 8.849 8.27446 8.849ZM4.83941 7.13149C4.60265 7.13149 4.41004 7.32411 4.41004 7.56089C4.41004 7.79764 4.60265 7.99026 4.83941 7.99026H8.27446C8.51122 7.99026 8.70383 7.79764 8.70383 7.56089C8.70383 7.32411 8.51122 7.13149 8.27446 7.13149H4.83941Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.84269 21.9459C7.61121 21.9459 7.42033 21.7617 7.41371 21.5288L6.98862 8.50744C6.98189 8.27038 7.1686 8.07276 7.40565 8.06603C7.64219 8.05958 7.8403 8.24601 7.84705 8.48304L8.27214 21.5044C8.27887 21.7414 8.09216 21.9391 7.85511 21.9458C7.85096 21.9459 7.84682 21.9459 7.84269 21.9459Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.4648 19.3876C14.2781 19.3876 14.1063 19.2648 14.0523 19.0764C13.8709 18.444 13.4973 17.9004 12.9719 17.5044C12.4465 17.1085 11.821 16.8992 11.163 16.8992C10.5051 16.8992 9.87963 17.1085 9.3542 17.5044C8.82875 17.9004 8.45517 18.444 8.27384 19.0764C8.20847 19.3043 7.97067 19.4363 7.74275 19.3708C7.51479 19.3054 7.38298 19.0677 7.44834 18.8397C7.68149 18.0266 8.16182 17.3277 8.83737 16.8186C9.51294 16.3095 10.3171 16.0405 11.163 16.0405C12.009 16.0405 12.8132 16.3095 13.4887 16.8186C14.1643 17.3277 14.6446 18.0266 14.8778 18.8397C14.9432 19.0677 14.8114 19.3054 14.5834 19.3708C14.5439 19.3821 14.504 19.3876 14.4648 19.3876Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.4811 21.5921C14.2439 21.5921 14.0517 21.3999 14.0517 21.1627V19.4452H13.0954C12.8583 19.4452 12.666 19.253 12.666 19.0158C12.666 18.7787 12.8583 18.5865 13.0954 18.5865H14.4811C14.7182 18.5865 14.9104 18.7787 14.9104 19.0158V21.1627C14.9104 21.3999 14.7182 21.5921 14.4811 21.5921ZM7.84509 21.5921C7.60795 21.5921 7.4157 21.3999 7.4157 21.1627V19.0158C7.4157 18.7787 7.60795 18.5865 7.84509 18.5865H9.23099C9.46813 18.5865 9.66038 18.7787 9.66038 19.0158C9.66038 19.253 9.46813 19.4452 9.23099 19.4452H8.27448V21.1627C8.27448 21.3999 8.08223 21.5921 7.84509 21.5921Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.7748 21.9625C18.5377 21.9625 18.3454 21.7703 18.3454 21.5331V12.5752H14.0516V17.4474C14.0516 17.6845 13.8594 17.8768 13.6222 17.8768C13.3851 17.8768 13.1929 17.6846 13.1929 17.4474V12.1458C13.1929 11.9086 13.3851 11.7164 13.6222 11.7164H18.7748C19.012 11.7164 19.2042 11.9086 19.2042 12.1458V21.5331C19.2042 21.7703 19.012 21.9625 18.7748 21.9625Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.272 12.1458C17.0348 12.1458 16.8426 11.9536 16.8426 11.7164V10.8576H15.5545V11.7164C15.5545 11.9535 15.3622 12.1458 15.1251 12.1458C14.8879 12.1458 14.6957 11.9536 14.6957 11.7164V10.4283C14.6957 10.1911 14.8879 9.99889 15.1251 9.99889H17.272C17.5091 9.99889 17.7014 10.1911 17.7014 10.4283V11.7164C17.7014 11.9535 17.5091 12.1458 17.272 12.1458Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.1985 10.4282C15.9614 10.4282 15.7691 10.236 15.7691 9.99884V8.7107C15.7691 8.47355 15.9614 8.28133 16.1985 8.28133C16.4357 8.28133 16.6279 8.47354 16.6279 8.7107V9.99884C16.6279 10.236 16.4357 10.4282 16.1985 10.4282Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.0572 14.2927H15.3398C15.1027 14.2927 14.9104 14.1005 14.9104 13.8633C14.9104 13.6262 15.1027 13.434 15.3398 13.434H17.0572C17.2944 13.434 17.4866 13.6262 17.4866 13.8633C17.4866 14.1005 17.2944 14.2927 17.0572 14.2927Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.0572 16.0103H15.3398C15.1027 16.0103 14.9104 15.8181 14.9104 15.5809C14.9104 15.3438 15.1027 15.1516 15.3398 15.1516H17.0572C17.2944 15.1516 17.4866 15.3438 17.4866 15.5809C17.4866 15.8181 17.2944 16.0103 17.0572 16.0103Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.0572 17.7279H15.3398C15.1027 17.7279 14.9104 17.5357 14.9104 17.2985C14.9104 17.0614 15.1027 16.8691 15.3398 16.8691H17.0572C17.2944 16.8691 17.4866 17.0614 17.4866 17.2985C17.4866 17.5357 17.2944 17.7279 17.0572 17.7279Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.3454 19.4455H14.481C14.2439 19.4455 14.0517 19.2532 14.0517 19.0161C14.0517 18.7789 14.2439 18.5865 14.4811 18.5865L18.3454 18.5867C18.5826 18.5867 18.7748 18.7789 18.7748 19.0161C18.7748 19.2532 18.5826 19.4455 18.3454 19.4455Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.1634 19.4452C10.9263 19.4452 10.7338 19.253 10.7338 19.0158C10.7338 18.7787 10.9259 18.5865 11.163 18.5865C11.4002 18.5865 11.5928 18.7787 11.5928 19.0158C11.5928 19.253 11.4005 19.4452 11.1634 19.4452Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CityViewIcon;
